import { PropsWithChildren } from 'react';
import { QuoteWizardQuestionInstance } from '../../../QuoteWizard/classes';
import { useUsingVagoSettings } from '../../../../hooks';
import { VagoLocationAccordionWrapper } from '../organizationSpecific/vago/VagoLocationAccordionWrapper';
import { ArrayFieldState } from 'informed';

export interface LocationWrapperProps extends PropsWithChildren<{}> {
  questionInstance: QuoteWizardQuestionInstance;
  justAdded: boolean;
  setJustAdded: (b: boolean) => void;
  openIndex: number | null;
  setOpenIndex: (i: number | null) => void;
  fields: ArrayFieldState['fields'];
}

/**
 * Wrapper component for location fields.
 * Conditionally wraps in VagoLocationAccordionWrapper if on Vago and apiName is 'risk_address',
 * otherwise just returns children.
 */
export const LocationWrapper = ({
  children,
  questionInstance,
  justAdded,
  setJustAdded,
  openIndex,
  setOpenIndex,
  fields,
}: LocationWrapperProps) => {
  const onVago = useUsingVagoSettings();

  // Only use VagoLocationAccordionWrapper on Vago and for risk_address
  if (onVago && questionInstance.apiName === 'risk_address') {
    return (
      <VagoLocationAccordionWrapper
        justAdded={justAdded}
        setJustAdded={setJustAdded}
        openIndex={openIndex}
        setOpenIndex={setOpenIndex}
        fields={fields}
      >
        {children}
      </VagoLocationAccordionWrapper>
    );
  }

  return <>{children}</>;
};
